import * as types from './actionTypes';
import firstBy from 'thenby';

const initialSettings = {
  ads: [],
  previews: [],
  selectedAd: {},
  store: {
    info1: '',
    info2: '',
    info3: '',
    info4: '',
    useLogo: false,
    logoUrl: '',
    previewUrl: ''
  },
  valid: false
};

const initialSearch = {
  petTypes: [],
  results: [],
  phrase: '',
  selectedPetTypes: []
};

const initialState = {
  list: [],
  petTypes: [],
  valid: false, 
  search: initialSearch,
  settings: initialSettings
};

export default function reducer(state = initialState, action = {}) {
  switch(action.type) {
    case types.CARESHEET_SETTINGS_RECEIVED: {
      // If we already have an ad selected, we need to update it with received data
      let selectedAd = {};
      if(Object.keys(state.settings.selectedAd).length !== 0) {
        selectedAd = action.payload.ads.find((ad) => {
          return ad.petType === state.settings.selectedAd.petType;
        });
      }
      
      return {
        ...state,
        settings: {
          ads: action.payload.ads,
          previews: action.payload.previews,
          selectedAd: selectedAd,
          store: {
            infoLine1: action.payload.store.infoLine1,
            infoLine2: action.payload.store.infoLine2,
            infoLine3: action.payload.store.infoLine3,
            infoLine4: action.payload.store.infoLine4,
            useLogo: action.payload.store.useLogo,
            logoUrl: action.payload.store.logoUrl,
            previewUrl: action.payload.store.previewUrl 
          },
          valid: true
        }
      };
    }
    case types.GET_CARESHEET_SETTINGS: {
      return {
        ...state,
        settings: initialSettings
      };
    }
    case types.AD_SELECTED: {
      return {
        ...state,
        settings: {
          ...state.settings,
          selectedAd: action.payload.ad
        }
      };
    }
    case types.AD_DESELECTED: {
      return {
        ...state,
        settings: {
          ...state.settings,
          selectedAd: {}
        }
        
      };
    }
    case types.CARESHEET_LIST_RECEIVED: {
      return {
        ...state,
        list: action.payload.caresheets,
        valid: true
      };
    }
    case types.PET_TYPES_ADDED: {
      return {
        ...state,
        search: {
          ...state.search,
          petTypes: action.payload.petTypes,
          selectedPetTypes: action.payload.selectedPetTypes
        }
      };
    }
    case types.TOGGLE_SELECTED_PET_TYPE: {
      let selectedPetTypes = [...state.search.selectedPetTypes];
      const togglePetType = action.payload.petType;
      
      let found = selectedPetTypes.find((petType) => {
        return petType === togglePetType;
      });
      
      if(found) {
        let index = selectedPetTypes.indexOf(togglePetType);
        selectedPetTypes.splice(index, 1);
      } else {
        selectedPetTypes.push(togglePetType);
      }

      return {
        ...state,
        search: {
          ...state.search,
          selectedPetTypes: selectedPetTypes
        }
      };
    }
    case types.FILTER_CARESHEETS: {
      const searchPhrase = state.search.phrase;
      
      const searchAllTypes = (state.search.petTypes.length === state.search.selectedPetTypes.length || 
                         state.search.selectedPetTypes.length === 0) ? true : false;

      let searchResults = state.list.filter((caresheet) => {
        if(searchAllTypes) {    
          return (caresheet.Line1 !== null && caresheet.Line1.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (caresheet.Line2 !== null && caresheet.Line2.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (caresheet.Line3 !== null && caresheet.Line3.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (caresheet.Line4 !== null && caresheet.Line4.toLowerCase().indexOf(searchPhrase) >= 0);
        } else {
          return (state.search.selectedPetTypes.includes(caresheet.Type)) && (
                 (caresheet.Line1 !== null && caresheet.Line1.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (caresheet.Line2 !== null && caresheet.Line2.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (caresheet.Line3 !== null && caresheet.Line3.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (caresheet.Line4 !== null && caresheet.Line4.toLowerCase().indexOf(searchPhrase) >= 0));
        }
      });

      searchResults.sort(firstBy("Line1")
                         .thenBy("Line2"));

      return {
        ...state,
        search: {
          ...state.search,
          results: searchResults
        }
      };
    }
    case types.CARESHEET_SEARCH_PHRASE: {
      let searchPhrase = '';
      if(action.payload.searchPhrase !== undefined) {
        searchPhrase = action.payload.searchPhrase.toLowerCase();
      } else {
        searchPhrase = '';
      }

      return {
        ...state,
        search: {
          ...state.search,
          phrase: searchPhrase
        }
      };
    }
    case types.CLEAR_SEARCH_RESULTS: {
      return {
        ...state,
        search: {
          ...state.search,
          results: [],
          phrase: '',
          selectedPetType: state.search.petTypes
        }
      };
    }
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/reducer.js
 **/